<template>
  <l-cache :get-data="getGroup" :id="$route.query.id" ref="cache">
    <group-form :group="data" @refresh="$refs.cache.retry(true)" slot-scope="{data}"></group-form>
  </l-cache>
</template>

<script>
import GroupForm from '../Group/groupForm'

export default {
  name: 'EditGroup',
  components: {GroupForm},
  data: () => ({
  }),
  methods: {
    async getGroup () {
      let {items} = await this.$store.dispatch('userAdmin/getGroups', {
        pagination: {page: 1, rowsPerPage: 10},
        filter: [{key: 'id', value: this.$route.query.id}],
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该分组')
      }
    },
  }
}
</script>

<style scoped>

</style>
